var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66729 7.33395V4.66862C8.66729 4.49181 8.59705 4.32224 8.47202 4.19722C8.347 4.07219 8.17743 4.00195 8.00062 4.00195C7.82381 4.00195 7.65424 4.07219 7.52922 4.19722C7.40419 4.32224 7.33395 4.49181 7.33395 4.66862V7.33395H4.66862C4.49181 7.33395 4.32224 7.40419 4.19722 7.52922C4.07219 7.65424 4.00195 7.82381 4.00195 8.00062C4.00195 8.17743 4.07219 8.347 4.19722 8.47202C4.32224 8.59705 4.49181 8.66729 4.66862 8.66729H7.33395V11.3326C7.33395 11.5094 7.40419 11.679 7.52922 11.804C7.65424 11.929 7.82381 11.9993 8.00062 11.9993C8.17743 11.9993 8.347 11.929 8.47202 11.804C8.59705 11.679 8.66729 11.5094 8.66729 11.3326V8.66729H11.3326C11.5094 8.66729 11.679 8.59705 11.804 8.47202C11.929 8.347 11.9993 8.17743 11.9993 8.00062C11.9993 7.82381 11.929 7.65424 11.804 7.52922C11.679 7.40419 11.5094 7.33395 11.3326 7.33395H8.66729Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d4a4bba439041f7c7dd1dd1d9fc760d0.svg";
export { ForwardRef as ReactComponent };